import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M18.5 12c0-.688-.563-1.25-1.25-1.25h-4v-4c0-.688-.563-1.25-1.25-1.25-.719 0-1.25.562-1.25 1.25v4h-4c-.719 0-1.25.563-1.25 1.25 0 .719.531 1.25 1.25 1.25h4v4c0 .719.531 1.25 1.25 1.25.687 0 1.25-.531 1.25-1.25v-4h4c.687 0 1.25-.531 1.25-1.25z" fill="#fff" /></svg>);